<template>
  <subscriptions v-if="accountGetIsEnabled && hasSubscriptionEnabled "/>
  <items-only v-else-if="accountGetIsEnabled && isCheckoutV2Enabled && !hasSubscriptionEnabled " />
  <payment-link v-else-if="accountGetIsEnabled && isCheckoutV2Enabled"/>
  <items v-else-if="accountGetIsEnabled" />
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import Items from './Items'
import ItemsOnly from './ItemsOnly'
import Subscriptions from './Subscriptions'
import { isAccountGetAllowed } from '@/action-permissions/account.permissions'
import PaymentLink from './PaymentLink'

export default {
  name: 'OrderType',
  components: {
    Items,
    ItemsOnly,
    Subscriptions,
    PaymentLink
  },
  beforeMount () {
    if (!this.hasSubscriptionEnabled) {
      const routes = this.computedRoutesWizard
      this.computedRoutesWizard = routes.map((item, idx) => {
        const isV1 = item.path === 'items' && !this.isCheckoutV2Enabled
        const isV2 = item.path === 'products-services' && this.isCheckoutV2Enabled

        if (isV1 || isV2) {
          this.SET_ITEM_PERMISSION({ index: idx, permission: true })
        }

        return item
      })
    }
  },
  computed: {
    ...mapGetters(['permissionIsEnabled', 'hasSubscriptionEnabled', 'routesWizard', 'accountSummary']),
    isCheckoutV2Enabled () {
      return this.accountSummary.checkout_v2_enabled
    },
    computedRoutesWizard: {
      get () {
        return this.routesWizard
      },
      set (value) {
        this.SET_ROUTES_WIZARD(value)
      }
    },
    accountGetIsEnabled () {
      return isAccountGetAllowed(this.permissionIsEnabled)
    }
  },
  methods: {
    ...mapActions(['SET_ROUTES_WIZARD', 'SET_ITEM_PERMISSION'])
  }
}
</script>
